import { render } from "./chart-component.vue?vue&type=template&id=3fcf3336&ts=true"
import script from "./chart-component.vue?vue&type=script&lang=ts"
export * from "./chart-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__